var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogoShort = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "logo-short",
  viewBox: "0 0 41 41"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  fill: "currentColor",
  cx: 20.5,
  cy: 20.5,
  r: 20.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  d: "M23.1,6.8c-4.3,0-6.9,2.6-8,8.4c-0.3,1.3-0.7,3.5-0.9,4.6c-0.6,3.6-1,5.7-1.7,6.4c-0.8,0.9-2.4,1.5-2.9,1.7l0.5,1.4l0.5,1.4c1.6-0.5,3.1-0.8,4.8-0.8h12.9l0.6-3H15.8c0.7-1.4,1.1-3.5,1.6-6.7c0.2-1,0.6-3.2,0.9-4.6c1.1-5.9,3.3-5.9,4.8-5.9c0.8,0,1.4,0.4,1.6,0.7c0.4,0.4,0.6,1,0.5,1.5c-0.4,2.2-1.4,3.1-4.4,3.3l-0.6,3c2.9-0.1,7.2-0.8,8.1-5.9c0.2-1.4-0.2-2.8-1.2-3.9C26.1,7.5,24.7,6.8,23.1,6.8"
})));
export default SvgLogoShort;